var _style, _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse2, _ellipse3, _path13, _rect, _path14, _rect2, _path15, _rect3, _rect4, _rect5, _path16, _rect6, _rect7, _ellipse4, _g, _g2, _g3, _g4, _g5, _g6, _path17, _path18, _path19, _path20;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarthVaderHilt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 200",
    style: {
      enableBackground: "new 0 0 35 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0dvh{fill:#6C6C6B;}\r\n\t.st1dvh{fill:#777776;}\r\n\t.st2dvh{fill:#2D2D2C;}\r\n\t.st3dvh{fill:#364697;}\r\n\t.st4dvh{fill:#868923;}\r\n\t.st5dvh{fill:#344194;}\r\n\t.st6dvh{fill:#848484;}\r\n\t.st7dvh{fill:#727322;}\r\n\t.st8dvh{fill:#2C3D76;}\r\n\t.st9dvh{fill:#1E3351;}\r\n\t.st10dvh{fill:#848587;}\r\n\t.st11dvh{fill:#2D2D2D;}\r\n\t.st12dvh{fill:#909091;}\r\n\t.st13dvh{fill:#5F5F5E;}\r\n\t.st14dvh{fill:#827E7E;}\r\n\t.st15dvh{fill:#676766;}\r\n\t.st16dvh{fill:#3F599F;}\r\n\t.st17dvh{fill:#364797;}\r\n\t.st18dvh{fill:#A8A7A7;}\r\n\t.st19dvh{fill:#959596;}\r\n\t.st20dvh{fill:#333333;}\r\n\t.st21dvh{fill:#141414;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0dvh",
    d: "M32.8,159.4c0.5,0,1,0,1.5,0c0.2,0.5,0.8,1.9,0.7,3.7c-0.1,1.2-0.4,2.2-0.6,2.7c-0.5,0-1,0-1.5,0 C32.9,163.7,32.8,161.5,32.8,159.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1dvh",
    d: "M31.6,161.2c0.2,0,0.4,0,0.6-0.1c0-0.7,0.1-1.1,0.2-1.4c0.1-0.2,0.1-0.3,0.2-0.3c0.2-0.1,0.4,0.2,0.4,0.2 c0.2,0.7,0.3,1.9,0.3,3.3c0,1.2-0.3,2.3-0.5,2.9c-0.1-0.1-0.3-0.2-0.5-0.4c-0.3-0.6-0.2-1.3-0.2-1.4c-0.2,0-0.4,0-0.6,0 C31.6,163.1,31.6,162.1,31.6,161.2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2dvh",
    cx: 30.9,
    cy: 175,
    rx: 0.6,
    ry: 3.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3dvh",
    d: "M32.1,156c-2.5,0-4.9,0-7.4,0c-0.8,2.1-1.6,4.1-2.4,6.2c-2.6,0.6-6.4,0.9-10.6-1c-1-0.5-2-1-2.8-1.6 c0,3.3,0,6.5,0,9.8c0.1,0.4,0.3,0.8,0.4,1.2c3.3,1,6.5,2,9.8,3.1c3.3-0.4,6.6-0.8,9.9-1.2c1.3-0.3,2.3-1.2,2.6-2.5 c0.1-0.3,0.1-0.6,0.1-1C31.7,164.7,31.9,160.3,32.1,156z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4dvh",
    d: "M32.7,171.9c0.5,0,1,0,1.5,0c0.2,0.5,0.8,1.9,0.7,3.7c-0.1,1.2-0.4,2.2-0.6,2.7c-0.5,0-1,0-1.5,0 C32.8,176.2,32.8,174,32.7,171.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5dvh",
    d: "M9,169.8c0,3.4,0,6.9,0,10.3c2.6,4.3,6.5,9.7,12,14.4c2.9,2.5,5.7,4.2,8.1,5.5c0-9.3,0-18.7,0-28 c-3,0.8-7.2,1.5-12.3,0.6C13.8,171.9,11.1,170.9,9,169.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6dvh",
    d: "M29.1,176.8c0.2,3,0.8,5.4,1.3,5.3c0.5-0.1,0.8-2.6,0.6-5.6c-0.2-3-0.8-5.4-1.3-5.3S28.9,173.8,29.1,176.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7dvh",
    d: "M31.6,173.7c0.2,0,0.4,0,0.6-0.1c0-0.7,0.1-1.1,0.2-1.4c0.1-0.2,0.1-0.3,0.2-0.3c0.2-0.1,0.4,0.2,0.4,0.2 c0.2,0.7,0.3,1.9,0.3,3.3c0,1.2-0.3,2.3-0.5,2.9c-0.1-0.1-0.3-0.2-0.5-0.4c-0.3-0.6-0.2-1.3-0.2-1.4c-0.2,0-0.4,0-0.6,0 C31.5,175.5,31.6,174.6,31.6,173.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3dvh",
    d: "M10.1,158.7c0.8,1,1.5,2.1,2.3,3.1c-1.1-0.2-2.2-0.4-3.3-0.7c-0.2-0.6-0.2-1.3,0.1-1.8 C9.5,158.7,10,158.7,10.1,158.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8dvh",
    d: "M29.3,117.7c0.3,0.6,0.2,1,0.2,1.2c-0.1,0.4-0.3,0.5-0.6,1c-0.2,0.4-0.4,0.8-0.5,1.1 c-5.6-0.2-11.2-0.4-16.7-0.6c0.1-1.1,0.1-2.2,0.2-3.2C17.7,117.4,23.5,117.5,29.3,117.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6dvh",
    d: "M10.1,161.3c0-14.3,0-28.6,0-43c0.6,0,1.3,0,1.9,0c0,0.6,0,1.2,0,1.8c2.4,0.4,5.1,0.6,8,0.6 c3.1,0,6-0.1,8.6-0.5c-0.1,15.5-0.1,30.9-0.2,46.4C22.3,164.9,16.2,163.1,10.1,161.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9dvh",
    d: "M28,136.5c0.8,0,1.6,0,2.4,0c0.2,0,0.5,0.1,0.7,0.5c0.5,0.6,0.4,1.7,0.4,2c-0.1,1.6,0.2,7.9,0.6,17.1 c-1.5,0-3,0-4.6,0c-0.1-4-0.1-8.2,0.1-12.8C27.7,140.9,27.8,138.7,28,136.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M22.7,147.5L22.7,147.5c-0.6,0-1.1-0.5-1.1-1.1v-5.9c0-0.6,0.5-1.1,1.1-1.1h0c0.6,0,1.1,0.5,1.1,1.1v5.9 C23.8,147,23.3,147.5,22.7,147.5z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11dvh",
    cx: 22.6,
    cy: 141.1,
    rx: 0.9,
    ry: 1.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11dvh",
    cx: 22.7,
    cy: 145.9,
    rx: 0.9,
    ry: 1.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12dvh",
    d: "M18,142.9h-1.5c-0.9,0-1.7-0.7-1.7-1.7l0,0c0-0.9,0.7-1.7,1.7-1.7H18c0.9,0,1.7,0.7,1.7,1.7l0,0 C19.6,142.1,18.9,142.9,18,142.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 140.3,
    className: "st13dvh",
    width: 2.9,
    height: 1.4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st12dvh",
    d: "M17.8,151.6h-1.5c-0.9,0-1.7-0.7-1.7-1.7l0,0c0-0.9,0.7-1.7,1.7-1.7h1.5c0.9,0,1.7,0.7,1.7,1.7l0,0 C19.5,150.8,18.7,151.6,17.8,151.6z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 149,
    className: "st13dvh",
    width: 2.9,
    height: 1.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14dvh",
    d: "M10.5,6.3c-0.1-1.2-0.1-2.3-0.2-3.5c1.9-1.2,5.5-2.9,10-2.8c3.6,0.1,6.5,1.4,8.3,2.5c0,1.2,0,2.4,0,3.6 C22.6,6.2,16.5,6.2,10.5,6.3z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 66.2,
    className: "st6dvh",
    width: 18.5,
    height: 25.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 4.7,
    className: "st15dvh",
    width: 18.5,
    height: 64.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.6,
    y: 91.3,
    className: "st16dvh",
    width: 3.6,
    height: 27
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17dvh",
    d: "M29.7,91.3c-0.1,9-0.1,18-0.2,27c-5.8,0-11.7,0-17.5,0c-0.3,0-0.5,0-0.8,0c0-9,0-18,0-27 C17.4,91.3,23.6,91.3,29.7,91.3z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 91.3,
    className: "st16dvh",
    width: 2.6,
    height: 27
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.4,
    y: 91.3,
    className: "st18dvh",
    width: 5.4,
    height: 27
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st19dvh",
    cx: 5.9,
    cy: 104.8,
    rx: 2,
    ry: 2.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20dvh",
    d: "M0,94.2c0,0.9,0.3,1.6,0.8,2v-3.9C0.3,92.6,0,93.4,0,94.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20dvh",
    d: "M0,98.2c0,0.9,0.3,1.6,0.8,2v-3.9C0.3,96.6,0,97.3,0,98.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20dvh",
    d: "M0,102.1c0,0.9,0.3,1.6,0.8,2v-3.9C0.3,100.5,0,101.2,0,102.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20dvh",
    d: "M0,106c0,0.9,0.3,1.6,0.8,2v-3.9C0.3,104.4,0,105.2,0,106z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20dvh",
    d: "M0,110c0,0.9,0.3,1.6,0.8,2V108C0.3,108.4,0,109.1,0,110z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20dvh",
    d: "M0,113.9c0,0.9,0.3,1.6,0.8,2V112C0.3,112.3,0,113.1,0,113.9z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st21dvh",
    d: "M11.2,6.8c0,20.9,0,41.7,0,62.6c-0.3,0.1-1.6,0.3-2.8-0.5c-1.5-0.9-1.9-2.6-2-2.9c0-18.4,0-36.8,0-55.1 c0-0.3,0.4-2.4,2.1-3.5C9.6,6.5,10.8,6.7,11.2,6.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st21dvh",
    d: "M28,6.5c0,20.9,0,41.7,0,62.6c0.3,0.1,1.6,0.3,2.8-0.5c1.5-0.9,1.9-2.6,2-2.9c0-18.4,0-36.8,0-55.1 c0-0.3-0.4-2.4-2.1-3.5C29.6,6.3,28.4,6.4,28,6.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st21dvh",
    d: "M23.9,4.4c0,21.7,0,43.4,0,65c0.2,0.1,1.1,0.3,2-0.5c1.1-1,1.4-2.7,1.4-3c0-19.1,0-38.2,0-57.3 c0-0.3-0.3-2.5-1.5-3.6C25,4.2,24.2,4.4,23.9,4.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st21dvh",
    d: "M16.4,4.7c0,21.7,0,43.4,0,65c-0.2,0.1-1.1,0.3-2-0.5c-1.1-1-1.4-2.7-1.4-3c0-19.1,0-38.2,0-57.3 c0-0.3,0.3-2.5,1.5-3.6C15.3,4.5,16.1,4.7,16.4,4.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarthVaderHilt);
export default __webpack_public_path__ + "static/media/darth-vader-hilt.1c040712.svg";
export { ForwardRef as ReactComponent };